import type { RouteRecordRaw } from 'vue-router';
import { AppScreens } from '@/shared/types';

export const profileRoute: RouteRecordRaw = {
  path: '/profile',
  component: () => import('@/modules/profile/views/Profile.vue'),
  name: AppScreens.Profile,
  meta: {
    layout: 'main',
  },
};
